import Commerce from 'types/models/Commerce';
import CommerceImage from 'types/models/CommerceImage';
import CommerceType from 'types/models/CommerceType';
import { PaymentConfig } from 'types/models/Venue';

export const parseCommerces = (commerces: []): Commerce[] => {
  return commerces.map((commerce: any) => parseCommerce(commerce));
};

export const parseCommerce = (commerce: any): Commerce => {
  return {
    id: commerce.id,
    name: commerce.name,
    phone: commerce.phone,
    code: commerce.code,
    editorId: commerce.editor_id,
    address: commerce.address,
    email: commerce.email,
    type: parseCommerceType(commerce.type),
    images: commerce.images ? parseCommerceImages(commerce.images) : [],
    paymentConfig: commerce.paymentConfig
      ? parseCommercePaymentConfig(commerce.paymentConfig)
      : commerce.payment_config
      ? parseCommercePaymentConfig(commerce.payment_config)
      : undefined,
  };
};

const parseCommerceImages = (images: any[]): CommerceImage[] => {
  return images.map((item) => ({
    commerceId: item.pivot?.commerce_id,
    commerceImageTypeId: item.pivot?.commerce_image_type_id,
    description: item.description,
    path: item.path,
  }));
};

const parseCommerceType = (type: any): CommerceType => {
  return {
    id: type.id,
    description: type.description,
  };
};

const parseCommercePaymentConfig = (paymentConfig: any): PaymentConfig => {
  return {
    id: paymentConfig.id,
    priorityOverCommerce: false,
    activePaymentProviderId: paymentConfig.active_payment_provider_id,
    cashEnabled: paymentConfig.cash_enabled,
    balanceEnabled: paymentConfig.balance_enabled,
    firstDataConfigId: paymentConfig.first_data_config_id,
    mpConfigId: paymentConfig.mp_config_id,
    cloverPointConfigId: paymentConfig.clover_point_config_id,
  };
};
